import {Box, Button, Text, useColorModeValue,} from "@chakra-ui/react";
import {AddIcon} from "@chakra-ui/icons";
import {useState} from "react";
import UploadDocumentModal from "../modals/UploadDocumentModal.tsx";


function PatientHeader() {
    const [openModal, setOpenModal] = useState(false);
    const textColor = useColorModeValue('black', 'white');
    return (
        <Box
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            height="64px"
            width="100%"
            px={4}
            boxSizing="border-box"
        >
            <UploadDocumentModal open={openModal} setOpen={setOpenModal}/>

            {/* Left label */}
            <Text fontSize="xl" fontWeight="bold" color={textColor}>
                Patients List
            </Text>

            {/* Right side buttons */}
            <Box display="flex" alignItems="center" gap={4}>
                <Button
                    leftIcon={<AddIcon/>}
                    bg="#422AFB"
                    color="white"
                    _hover={{bg: "#5842ff"}}
                    textTransform="none"
                    fontWeight="bold"
                    height="40px"
                    // onClick={() => navigate('/upload')}
                    onClick={() => setOpenModal(true)}
                >
                    Create Patient Report
                </Button>
            </Box>
        </Box>
    );
}

export default PatientHeader;
